// extracted by mini-css-extract-plugin
export default {"block":"tuning_block__NxgIO","choice":"tuning_choice__m683j","sel":"tuning_sel__0KwzL"};